import {pxToRem} from '../../../../utills/pxToRem'

export const normalTextStyle = {
    fontSize: {base: pxToRem(12), lg: pxToRem(13)},
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const tileHeadingStyle = {
    fontFamily: 'Montserrat',
    fontSize: {base: 'md', lg: 'lg'},
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: {base: pxToRem(2), lg: pxToRem(3)},
    textTransform: 'uppercase',
    mb: '0'
}

export const pageContainerStyle = {
    gap: {base: pxToRem(15), lg: pxToRem(25)},
    mt: {base: pxToRem(15), lg: pxToRem(64)},
    mb: {base: pxToRem(30), lg: pxToRem(40)},
    paddingX: {base: pxToRem(11), lg: pxToRem(45)},
    h1: {
        mb: '0 !important',
        fontFamily: 'Montserrat',
        fontWeight: 'semibold',
        fontSize: {base: 'lg', lg: pxToRem(22)},
        lineHeight: 'normal',
        letterSpacing: '3px'
    },
    '.tile': {
        display: 'flex',
        flexDir: 'column',
        layerStyle: 'cardBordered',
        padding: {base: pxToRem(15), lg: `${pxToRem(23)} ${pxToRem(18)}`},
        gap: {base: pxToRem(10), lg: pxToRem(10)},
        boxShadow: `${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} rgba(0, 0, 0, 0.25)`,
        mt: '0 !important',
        h2: {
            ...tileHeadingStyle
        },
        p: {
            ...normalTextStyle,
            mt: '0 !important'
        },
        '.order-info': {
            flexDir: {base: 'column', lg: 'row'},
            gap: {base: pxToRem(5), lg: pxToRem(25)},
            ...normalTextStyle,
            textTransform: 'capitalize',
            mt: '0 !important',
            div: {
                mt: '0 !important',
                span: {
                    _first: {
                        fontWeight: 'medium'
                    }
                }
            }
        }
    },
    '.shopNow-btn': {
        maxWidth: {base: pxToRem(260), lg: pxToRem(295)}
    }
}

export const productImageStyle = {
    templateColumns: {base: 'repeat(auto-fit, 82px)', lg: 'repeat(auto-fit, 130px)'},
    gap: pxToRem(10),
    mt: '0 !important'
}

export const orderInfoListStyle = {
    flexDir: {base: 'column', lg: 'row'},
    gap: {base: pxToRem(5), lg: pxToRem(15)},
    hr: {
        mt: '0 !important',
        borderColor: 'cav_light_input_gray',
        bg: 'cav_light_input_gray',
        width: pxToRem(1),
        display: {base: 'none', lg: 'initial'}
    },
    span: {
        ...normalTextStyle,
        flexShrink: '0'
    },
    a: {
        ...normalTextStyle,
        textDecoration: 'underline'
    },
    mt: '0 !important'
}

export const orderInfoContainerStyle = {
    flexDir: 'column',
    justifyContent: {base: '', lg: 'space-between'},
    gap: {base: pxToRem(20), lg: pxToRem(10)}
}

export const orderDetailLink = {
    fontSize: 'xs',
    fontWeight: 'medium',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    color: 'cav_red',
    textTransform: 'uppercase',
    textDecoration: 'underline',
    textAlign: 'right',
    mt: '0 !important'
}

export const noOrdersTile = {
    alignItems: {base: 'center', lg: 'start'},
    textAlign: {base: 'center', lg: 'start'},
    a: {
        minWidth: {base: pxToRem(260), lg: pxToRem(295)}
    }
}
